var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._t("title")], 2),
      _vm.tasks.length > 0
        ? _c(
            "w-scroll-view",
            { attrs: { tag: "w-card-content" } },
            _vm._l(_vm.tasks, function (task) {
              return _c("app-task-item", {
                key: task.ID,
                attrs: { value: task },
                on: {
                  open: function ($event) {
                    return _vm.openTask(task)
                  },
                },
              })
            }),
            1
          )
        : _c(
            "w-row",
            { attrs: { grow: "", center: "" } },
            [
              _c(
                "w-col",
                { attrs: { center: "" } },
                [
                  _c("w-fa", {
                    staticClass: "checkmark gray",
                    attrs: { icon: "check" },
                  }),
                  _c("div", { staticClass: "gray mt" }, [
                    _vm._v(" " + _vm._s(_vm.$ct("no-pending-tasks")) + " "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }